<template>
<div class="clearfix">
    <div class="container">
        <el-card class="card">
            <span class="title">重置密码</span>
            <span class="span-hint" v-show="!phone_status">{{phone_hint}}</span>
            <div class="item-row">
              <div class="span-label">手机号</div>
              <el-input placeholder="请输入手机号" size="medium" v-model="phone" @blur='phoneOnBlur' maxlength=11 clearable></el-input>
            </div>
            <span class="span-hint" v-show="!verify_status">{{verify_hint}}</span>
            <div class="item-row">
              <span class="span-label">验证码</span>
              <el-input style="width: 58%;" placeholder="输入验证码" size="medium" v-model="verify_code" @blur='verifyOnBlur' maxlength=11 clearable autocomplete="new-password"></el-input>
              <el-button class="btn-verify-set" size="medium" @click="getVerifyCode" type="primary" :disabled="verify_disable">{{btn_verify}}</el-button>
            </div>
            <span class="span-hint" v-show="!password_status">{{password_hint}}</span>
            <div class="item-row">
              <span class="span-label">新密码</span>
              <el-input placeholder="请输入新密码" size="medium" autocomplete="new-password" v-model="password" @blur='passwordOnBlur' minlength=6 show-password></el-input>
            </div>
            <span class="span-hint" v-show="!password_confirm_status">{{password_confirm_hint}}</span>
            <div class="item-row">
              <span class="span-label">新密码确认</span>
              <el-input placeholder="请再次输入新密码" size="medium" autocomplete="new-password" v-model="passwordConfirm" @blur='passwordConfirmOnBlur' @keyup.enter.native="setPasswordConfirm" minlength=6 show-password></el-input>
            </div>
            <div class="item-column">
                <el-button class="btn-confirm" size="medium" type="primary" @click="setPasswordConfirm">确 定</el-button>
            </div>
        </el-card>
    </div>
</div>
</template>
<script>
export default {
    data () {
        return {
            phone_hint:'请输入手机号',
            phone_status:true,
            phone:'',
            verify_hint:'请输入验证码',
            verify_status:true,
            verify_code:'',
            password_hint:'请输入密码',
            password_status:true,
            password:'',
            password_confirm_hint:'请再次输入密码',
            password_confirm_status:true,
            passwordConfirm:'',
            btn_verify:'获取验证码',
            verify_disable:false,
            verify_second:60,
        }
    },
    created() {
      var phone = this.$route.query.phone
      if(phone){
        this.phone = phone
      }
    },
    methods:{
        getVerifyCode(){
            if(this.phone.length == 0){
                this.$message({
                    message: '请先填写手机号',
                    type: 'fail'
                });
                return
            }
            if(this.phone.length < 11){
                this.$message({
                    message: '请先填写正确的手机号',
                    type: 'fail'
                });
                return
            }
            var codeParams = {
                telephone:this.phone,
                phoneMd5:this.$md5(this.phone),
                type:'resetpwd'
            }
            this.wjtHttp.get(this,'/api/smsCode',codeParams,false,(res)=>{
                var data = res.data
                if(data.code == 200){
                    this.$message({
                        message:'发送成功',
                        type:'success'
                    })
                    this.verify_disable = true
                    clearInterval(this.mInterval)
                    this.mInterval = setInterval(() => {
                        if(this.verify_second == 0){
                            this.verify_disable = false
                            this.verify_second = 60
                            clearInterval(this.mInterval)
                            return
                        }
                        this.verify_second--
                    }, 1000);
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'服务异常，请联系管理员',
                        type:'error'
                    })
                }
            })
        },
        phoneOnBlur(){
            if(this.phone.length == 0){
                this.phone_status = false
                this.phone_hint='请输入手机号码'
            }else if(this.phone.length < 11 || this.phone.length > 11){
                this.phone_status = false
                this.phone_hint='请输入正确的手机号码'
            }else{
                this.phone_status = true
            }
        },
        verifyOnBlur(){
            if(this.verify_code.length == 0){
                this.verify_status = false
                this.verify_hint='请输入验证码'
            }else{
                this.verify_status = true
            }
        },
        passwordOnBlur(){
            if(this.password.length == 0){
                this.password_status = false
                this.password_hint='请输入密码'
            }else if(this.password.length < 6){
                this.password_status = false
                this.password_hint = '密码必须大于六位'
            }else{
                this.password_status = true
            }
        },
        passwordConfirmOnBlur(){
            if(this.passwordConfirm.length == 0){
                this.password_confirm_status = false
                this.password_confirm_hint='请再次输入密码'
            }else if(this.passwordConfirm != this.password){
                this.password_confirm_status = false
                this.password_confirm_hint = '两次密码不匹配'
            }else{
                this.password_confirm_status = true
            }
        },
        setPasswordConfirm(){
            if(this.phone.length == 0){
                this.$message({
                    message: '请输入手机号',
                    type: 'warning'
                });
                return
            }
            if(this.phone.length < 11){
                this.$message({
                    message: '请输入正确的手机号',
                    type: 'warning'
                });
                return
            }
            if(this.password.length == 0){
                this.$message({
                    message: '请输入密码',
                    type: 'warning'
                });
                return
            }
            if(this.password.length < 6){
                this.$message({
                    message: '密码不能小于六位',
                    type: 'warning'
                });
                return
            }
            if(this.password != this.passwordConfirm){
                this.$message({
                    message: '两次密码不匹配',
                    type: 'warning'
                });
                return
            }
            if(this.verify_code.length == 0){
                this.$message({
                    message: '请输入验证码',
                    type: 'warning'
                });
                return
            }
            var vParams = {
                code:this.verify_code,
                username:this.phone,
                phoneMd5:this.$md5(this.phone),
                password:this.password
            }
            this.wjtHttp.post(this,'/api/resetPwd',vParams,false,(res)=>{
                    var data = res.data
                    if(data.code == 200){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        if(!this.utils.isEmptyStr(this.fromPath) && this.fromPath != '/'){
                            this.$router.go(-1)
                        }else{
                            this.$router.replace('/')
                        }
                    }else{
                        this.$message({
                            message:(data.msg&&data.msg.length > 0)?data.msg:'服务异常，请联系管理员',
                            type:'error'
                        })
                    }
                })
        }

    },
    beforeRouteEnter(to,from,next){
        next(vm =>{
            vm.fromPath = from.path
        })
    },
    watch:{
        verify_disable:function(val){
            if(val){
                this.btn_verify = this.verify_second+'后重发'
            }else{
                this.btn_verify = '获取验证码'
            }
        },
        verify_second:function(val){
            if(val < 60){
                this.btn_verify = val + '后重发'
            }
        },
        login_type:function(val){
            if(val == 'verify'){
                this.login_change_text = '密码登录'
            }else{
                this.login_change_text = '忘记密码？'
            }
        }
    }
}
</script>
<style scoped>
    .container{
        margin: 0 auto;
        position: relative;
    }
    .clearfix:after, .clearfix:before {
        content: " ";
        display: table;
    }
    .span-label{
      width: 120px;
      text-align: left;
    }
    .card{
        margin: 40px auto;
        padding: 5% 5%;
        background-color: #fff;
        max-width: 420px;
        width: 100%;
    }
    .title{
        text-align: center;
        font-size: 22px;
        color: #333333;
        position: relative;
        bottom: 20px;
    }
    .span-hint{
        display: flex;
        width: 100%;
        font-size: 14px;
        color: #ff5a05;
        margin-bottom: 5px;
        margin-left: 90px;
        text-align: left;
    }
    .item-column{
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .item-row{
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding-bottom: 35px;
    }
    .btn-verify-set{
        margin-left: 18px;
    }
    .span-password-login{
        width: 90px;
        height: 100%;
        font-size: 16px;
        color: #FE9400;
        text-align: right;
    }
    .span-change-verify{
        font-size: 16px;
        color: #FE9400;
        text-align: center;
        padding: 8px 0;
    }
    .btn-confirm{
        width: 50%;
        margin-left: 25%;
        height: 45px;
        margin-top: 62px;
    }
    .span-third-login{
        font-size: 16px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        color: #333333;
    }
    .img-wx{
        width: 36px;
        height: 36px;
        margin-top: 20px;
        position: relative;
        margin-left: calc(50% - 16px);
    }
    .span-signup-text{
        width: calc(100% - 90px);
        font-size: 16px;
        text-align: left;
        color: #333333;
        display: flex;
        align-items: center;
    }
    .span-signup-text>span{
        font-size: 16px;
        color: #FE9400;
    }
</style>



// WEBPACK FOOTER //
// src/components/account/ResetPassword.vue